import { useCallback } from 'react'

import { UploadItem } from '../../types'

interface UseWidgetHandlersProps {
  activeUploads: UploadItem[]
  uploadsArray: UploadItem[]
  cancelUpload: (id: string) => void
  removeUpload: (id: string) => void
  addFiles: (files: File[]) => Promise<void>
}

export const useWidgetHandlers = ({
  activeUploads,
  uploadsArray,
  cancelUpload,
  removeUpload,
  addFiles
}: UseWidgetHandlersProps) => {
  const handleCancelAll = useCallback(() => {
    activeUploads.forEach((upload) => {
      cancelUpload(upload.id)
    })
  }, [activeUploads, cancelUpload])

  const handleClose = useCallback(() => {
    uploadsArray.forEach((upload) => {
      removeUpload(upload.id)
    })
  }, [uploadsArray, removeUpload])

  const handleAddFiles = useCallback(
    async (files: File[]) => {
      await addFiles(files)
    },
    [addFiles]
  )

  return {
    handleCancelAll,
    handleClose,
    handleAddFiles
  }
}
